import { getRsocketClient } from '~/components/sportsbook/lobby/api/betting-service/rsocket-client';

export const connectToRSocket = () => getRsocketClient().connect();
export const disconnectFromRsocket = () => getRsocketClient().disconnect();
export const updateBettingSessionExpiration = (bettingSessionExpiresOn: string | null) =>
	getRsocketClient().updateBettingSessionExpiration(bettingSessionExpiresOn);
